import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { Typo, Modal, Scrollbars, Accordions, Accordion } from '@ers/ui/';
import { useModal } from '@ers/hooks/';
import { Faqs } from '@ers/data';
import MenuItemBody from './Navigation/MenuItemBody';


const FaqTopBarTrigger = ({ openModal }) => (
    <MenuItemBody
        className="user-box__menu-item"
        handleClick={openModal}
    >
        <Typo.Body>Pomoc</Typo.Body>
    </MenuItemBody>
);
FaqTopBarTrigger.propTypes = {
    openModal: PropTypes.func.isRequired,
};

export const FaqModal = ({ children }) => {
    const [isVisible, openModal, hideModal] = useModal(false);
    const visibleHeader = (count) => count * 57 + count - 1;
    return (
        <>
            {React.cloneElement(children, { openModal })}
            {isVisible && (
                <Modal close={hideModal} title="Pomoc">
                    <Typo.Body className="with-margin--bottom-2">
                        Wybierz temat który Cię interesuje:
                    </Typo.Body>
                    <Scrollbars style={{ minHeight: visibleHeader(7), height: 'auto' }}>
                        <Accordions>
                            {Faqs.map(({ question, answer: Answer }) => {
                                const id = uuid();
                                return (
                                    <Accordion id={id} key={question} title={question}>
                                        <Answer />
                                    </Accordion>
                                );
                            })}
                        </Accordions>
                    </Scrollbars>
                </Modal>
            )}
        </>
    );
};
const Faq = () => (
    <FaqModal>
        <FaqTopBarTrigger />
    </FaqModal>
);

export default Faq;
